import { createFileRoute } from "@tanstack/react-router";
import { TasksOverviewPage } from "@/pages/tasks-overview/ui/tasks-overview-page";
import { preloadTaskOverviewQueries } from "@/pages/tasks-overview/api/preload-task-overview-queries";
import { searchParams } from "@/pages/tasks-overview/model/search-params";

const TasksOverviewRoute = () => {
  return (
    <>
      <TasksOverviewPage />
    </>
  );
};

export const Route = createFileRoute("/_authed/$companySlug/tasks")({
  component: TasksOverviewRoute,
  validateSearch: searchParams,
  loader: ({ context }) => {
    // company is guaranteed by $companySlug beforeLoad redirect guard
    if (context.company) {
      void preloadTaskOverviewQueries(context.company.id);
    }
  },
});
